// extracted by mini-css-extract-plugin
export default {"socialMedia":"SocialMedia_socialMedia__yTPjB","cardWrapper":"SocialMedia_cardWrapper__KSFZv","youtube":"SocialMedia_youtube__pFek6","facebook":"SocialMedia_facebook__I64IO"};